import {useQuotes} from "../QuotesContext";
import EmailViewerPage from "../../Templates/EmailViewerPage";

const QuoteEmailViewer = () => {
    const {selectedQuote: quote, quoteEmailViewerDialog} = useQuotes();
    const title = `Preventivo ${quote.surname || ""} ${quote.name || ""}`;

    return <>{
        quote.id && <EmailViewerPage emailMessageId={quote.emailMessage.id}
                                     title={title}
                                     onClose={quoteEmailViewerDialog.close}/>
    }</>;
}

export default QuoteEmailViewer;